/**
 * @NOTE: All text helpers should be placed here.
 */

const text = null;

export const stripParagraphTag = (str = '') => str.replace(/<\/?p[^>]*>/g, '');

export const isolateStrongPerWord = (str = '') =>
  str.replace(/<strong>(.*?)<\/strong>/g, match =>
    match
      .replace(/(<strong>|<\/strong>)/g, '')
      .split(' ')
      .map(word => `<strong>${word}</strong>`)
      .join(' ')
  );

export const isolateSpanPerWord = (str = '') =>
  str.replace(/<span>(.*?)<\/span>/g, match =>
    match
      .replace(/(<span>|<\/span>)/g, '')
      .split(' ')
      .map(word => `<span>${word}</span>`)
      .join(' ')
  );

export const isolateLinkPerWord = (str = '') =>
  str.replace(/<a[^>]*>([^<]+)<\/a>/g, link => {
    const words = link.replace(/(<a[^>]*>|<\/a>)/g, '').split(' ');
    const href = link.match(/href="([^"]+)"/g);
    return words.map(word => `<a ${href}>${word} </a>`).join(' ');
  });

export const stripLinkTag = (str = '') => str.replace(/<a\b[^>]*>/g, '').replace(/<\/a>/g, '');

// Inherit custom styles of element's child.
export const inheritChildStyle = (
  parentElement,
  childTagName,
  parentStyleToChange,
  childStyleToInherit = 'color'
) => {
  if (parentElement) {
    const childElement = parentElement.getElementsByTagName(childTagName);

    if (childElement.length) {
      Array.from(childElement).forEach(elem => {
        if (elem.children.length) {
          const elemInside = elem.children[0];

          elem.style[parentStyleToChange] = elemInside.style[childStyleToInherit];
        }
      });
    }
  }
};

/**
 * Capitalize the first letter of the text.
 * @param {string} str Text to be capitalized.
 * @return {string} Will return the converted text.
 */
export const capitalize = str => str.replace(/^\w/, c => c.toUpperCase());

export const cleanURL = (str = '') => encodeURI(str.replace(/([^:]\/)\/+/g, '$1'));

export default text;
